<template>
  <v-row no-gutters>
    <v-col cols="12" v-if="fetched">
      <v-treeview open-all :items="computedValue ? [computedValue] : []" class="text-left px-10">
        <template #append="{item}">
          <v-row no-gutters align="center" v-if="item.children && !readOnly">
            <v-col cols="auto" style="position: absolute; left: -30px">
              <v-btn
                v-if="hasAddingChild(item)"
                fab
                color="success"
                x-small
                @click="addChild(item, flatTreeview[item.metadata.layer]?.children[0])"
              >
                <v-icon color="white" :size="15">
                  mdi-plus
                </v-icon>
              </v-btn>
              <v-menu offset-y close-on-content-click attach min-width="200px" v-else-if="hasAddingChildren(item)">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" fab color="success" x-small>
                    <v-icon color="white" :size="15">
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    dense
                    class="text-body-2"
                    v-for="(child, idx) of flatTreeview[item.metadata.layer].children"
                    :key="idx"
                    @click="addChild(item, child)"
                  >
                    {{ layers[child.layer]?.name }}
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </template>
        <template #label="{item}">
          <v-row no-gutters align="center">
            <v-col cols="auto"> {{ layers[item.metadata?.layer]?.name }} </v-col>
            <template v-if="item.key !== '0' && !readOnly">
              <v-spacer />
              <v-col cols="auto">
                <v-icon color="error" @click="deleteChild(item)">
                  mdi-close
                </v-icon>
              </v-col>
            </template>
          </v-row>
        </template>
      </v-treeview>
    </v-col>
    <main-loader v-else class="pt-7" />
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';
import { get as lodashGet } from 'lodash';
import MainLoader from '@/components/MainLoader';
export default {
  name: 'TreeviewPattern',
  components: { MainLoader },
  props: {
    treeview: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    layers: get('layers/layers'),
    computedValue: {
      get() {
        const mapItemKey = (item, index = 0, parent = { key: '' }) => {
          item.key = parent.key ? `${parent.key}-${index}` : '0';
          if (item.children) item.children = item.children.map((child, i) => mapItemKey(child, i, item));
          return item;
        };
        return this.value && Object.keys(this.value)?.length ? mapItemKey(JSON.parse(JSON.stringify(this.value))) : {};
      },
      set(value) {
        const deleteItemKey = item => {
          delete item.key;
          if (item.children) item.children = item.children.map(child => deleteItemKey(child));
          return item;
        };
        this.$emit('input', deleteItemKey(JSON.parse(JSON.stringify(value))));
      },
    },
    flatTreeview() {
      return this.$_arrayToObject(this.$_flattenStructure([this.treeview], 'children', true), 'layer');
    },
  },
  data: () => ({
    fetched: false,
  }),
  methods: {
    hasAddingChild(item) {
      return this.flatTreeview[item.metadata.layer]?.children.length === 1;
    },
    hasAddingChildren(item) {
      return this.flatTreeview[item.metadata.layer]?.children.length >= 2;
    },
    addChild(item, treeviewMetadata) {
      const valueCopy = JSON.parse(JSON.stringify(this.computedValue));
      const parentPath = item.key.split('-');
      const parent = lodashGet([valueCopy], parentPath);
      this.$set(parent, 'children', [...parent.children, this.mapOnTreeElement(treeviewMetadata)]);
      this.computedValue = valueCopy;
    },
    deleteChild(item) {
      const valueCopy = JSON.parse(JSON.stringify(this.computedValue));
      const keySplit = item.key.split('-');
      const elementIndex = keySplit[keySplit.length - 1];
      const parentPath = keySplit.slice(0, keySplit.length - 1);
      const parent = lodashGet([valueCopy], parentPath);
      this.$delete(parent.children, elementIndex);
      this.computedValue = valueCopy;
    },
    mapOnTreeElements(items) {
      return items.map(item => this.mapOnTreeElement(item));
    },
    mapOnTreeElement(item) {
      return {
        ...(item.children?.length ? { children: this.mapOnTreeElements(item.children) } : {}),
        geometry: null,
        metadata: {
          datasource: item.datasource,
          layer: item.layer,
        },
        properties: {},
      };
    },
  },
  watch: {
    computedValue: {
      handler(nV) {
        if (!nV || !Object.keys(nV)?.length) {
          // Set default treeview if it's empty
          this.computedValue = this.mapOnTreeElements([this.treeview])[0];
        } else if (nV && Object.keys(nV)?.length) {
          this.fetched = true;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
